import { Injectable } from '@angular/core';
import {HttpObservable, HttpWrapper} from '../../common/http-helpers/http.wrapper';
import {
  IChangePasswordRequest,
  ICreateAccountRequest,
  ICreateAccountResponse,
  ILocatePatientResponse,
  IOneTimeCodeGenerationResponse,
  IOneTimeCodeValidationRequest,
  IOneTimeCodeValidationResponse,
  IChangePasswordResponse
} from '../login/login-internal/common/common.types';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatientAccountProxy {

  constructor(private httpWrapper: HttpWrapper) {
  }

  public locatePatient(patientData: any): HttpObservable<ILocatePatientResponse> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'LocatePatient', {patient:patientData}, null);
  }

  public createPatientAccount(patientDataWithAccountDetails: ICreateAccountRequest): HttpObservable<ICreateAccountResponse> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'createPatientAccount', patientDataWithAccountDetails, null);
  }

  public generatePatientUserName(patientData: any): HttpObservable<string> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'GeneratePatientUserName', patientData, null).pipe(map(res => res.userName));
  }

  public getPatientUserName(patientData: any): HttpObservable<string> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'GetPatientUserName', patientData, null).pipe(map(res => res.userName));
  }

  public generateOneTimeCode(patientData: any): HttpObservable<IOneTimeCodeGenerationResponse> {
    if (!('model' in patientData)){
      // may receive the patient directly without the "model" wrapper
      patientData={model:{patient:patientData}};
    }
    return this.httpWrapper.putAnon('PatientPortalAccount', 'GenerateOneTimeCode', patientData, null);
  }

  public validateOneTimeCode(oneTimeCodeData: IOneTimeCodeValidationRequest): HttpObservable<IOneTimeCodeValidationResponse> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'ValidateOneTimeCode', oneTimeCodeData, null);
  }

  public changePassword(userCredentials: IChangePasswordRequest): HttpObservable<IChangePasswordResponse> {
    return this.httpWrapper.putAnon('PatientPortalAccount', 'ChangePassword', userCredentials, null);
  }
}
